/* DropAvanzado · Revelado al hacer scroll */
(function() {
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    function initReveals() {
      // Aplicar a las secciones principales de la PDP y homepage
      var selectors = [
        '.dropavanzado-historia',
        '.dropavanzado-pasos',
        '.dropavanzado-antes-despues',
        '.dropavanzado-caracteristicas',
        '.dropavanzado-beneficios',
        '.dropavanzado-comparativa',
        '.dropavanzado-faq',
        '.dropavanzado-testis'
      ];
      selectors.forEach(function(sel, idx) {
        document.querySelectorAll(sel).forEach(function(el) {
          if (!el.classList.contains('da-reveal')) {
            el.classList.add('da-reveal');
            el.style.setProperty('--da-reveal-delay', (idx % 3 * 0.08) + 's');
            observer.observe(el);
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReveals);
    } else {
      initReveals();
    }
  }
})();
